// extracted by mini-css-extract-plugin
export default {"truncateBranch":"PullRequestHeaderSummary-module__truncateBranch--u_0Mq","summaryContainer":"PullRequestHeaderSummary-module__summaryContainer--ah8Ua"};